import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalaDePrensaComponent } from './pages/sala-de-prensa/sala-de-prensa.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { PrensaListingBlockComponent } from './components/prensa-listing-block/prensa-listing-block.component';
import { ArticuloComponent } from './pages/articulo/articulo.component';
import { ArticuloPreviewComponent } from './pages/articulo-preview/articulo-preview.component';


@NgModule({
  declarations: [
    SalaDePrensaComponent,
    PrensaListingBlockComponent,
    ArticuloComponent,
    ArticuloPreviewComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ]
})
export class SalaDePrensaModule { }
